const dataScreenZh = {
  //默认大屏
  scDefaultLang: {
    电站指标: ' 电站指标',
    个: '个',
    电站总数: '电站总数',
    年1: '年',
    年2: '年',
    天: '天',
    安全运行时间: '安全运行时间',
    总装机功率: '总装机功率',
    总装机容量: '总装机容量',
    电量趋势: '电量趋势',
    大屏总充电量: '大屏总充电量',
    大屏总放电量: '大屏总放电量',
    社会公益: '社会公益',
    'CO2减排(吨)': 'CO2减排(吨)',
    '节约标准煤(吨)': '节约标准煤(吨)',
    '等效植树量(棵)': '等效植树量(棵)',
    '累计收益/元': '累计收益/元',
    收益指标: '收益指标',
    '当日/元': '当日/元',
    '当月/万元': '当月/万元',
    收益趋势: '收益趋势',
    近7日: '近7日',
    近31日: '近31日',
    近12月: '近12月',
    收益排行: '收益排行',
    星期日: '星期日',
    星期一: '星期一',
    星期二: '星期二',
    星期三: '星期三',
    星期四: '星期四',
    星期五: '星期五',
    星期六: '星期六',
    智慧储能数据云平台: '智慧储能数据云平台',

    返回: '返回',
    累计收益: '累计收益',
    万元: '万元',
    大屏总充电: '大屏总充电',
    大屏总放电: '大屏总放电',
    装机容量: '装机容量',
    装机功率: '装机功率',
    电站地址: '电站地址',
    收益: '收益',
    充电量: '充电量',
    放电量: '放电量'
  },
  //华友大屏
  scHyLang: {
    电量指标: '电量指标',
    大屏总充电量: '大屏总充电量',
    大屏总放电量: '大屏总放电量',
    电量趋势: '电量趋势',
    电站安全: '电站安全',
    '安全运行时间(天)': '安全运行时间(天)',
    '电站总数(个)': '电站总数(个)',
    总装机功率: '总装机功率',
    总装机容量: '总装机容量',
    收益指标: '收益指标',
    '累计收益/万元': '累计收益/万元',
    '今日收益/元': '今日收益/元',
    收益趋势: '收益趋势',
    按日: '按日',
    按周: '按周',
    按月: '按月',
    排名: '排名',
    'CO2减排(吨)': 'CO2减排(吨)',
    '节约标准煤(吨)': '节约标准煤(吨)',
    '等效植树量(棵)': '等效植树量(棵)',
    星期日: '星期日',
    星期一: '星期一',
    星期二: '星期二',
    星期三: '星期三',
    星期四: '星期四',
    星期五: '星期五',
    星期六: '星期六',

    单位: '单位',
    '单位/万元': '单位/万元',
    万元: '万元',
    收益: '收益',
    充电量: '充电量',
    放电量: '放电量',
    返回: '返回'
  }
}
export default dataScreenZh
